import { render, staticRenderFns } from "./number-one.vue?vue&type=template&id=0801c41a&scoped=true"
import script from "./number-one.vue?vue&type=script&lang=js"
export * from "./number-one.vue?vue&type=script&lang=js"
import style0 from "./number-one.vue?vue&type=style&index=0&id=0801c41a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0801c41a",
  null
  
)

export default component.exports